var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled),expression:"!disabled"}],staticClass:"smvp-notifications"},[_c('loading',{attrs:{"player-state-repository":_vm.playerStateRepository}}),_c('error-notification',{attrs:{"event-bus":_vm.eventBus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }